<template>
    <action-icon :icon="status ? 'LockIcon' : 'UnlockIcon'" :tooltip="status ? $t('lock') : $t('unlock')" @click="confirm" />
</template>

<script>
import request from '../request'
import ActionIcon from '@/views/qb-components/actions/ActionIcon'

export default {
    components: {
        ActionIcon,
    },
    props: {
        id: {
            type: String,
            required: true
        },
        status: {
            type: Boolean,
            required: true
        }
    },
    methods: {
        confirm(item) {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: this.$i18n.messages[this.$i18n.locale].confirm,
                text: this.$i18n.messages[this.$i18n.locale].confirm_message,
                acceptText: this.$i18n.messages[this.$i18n.locale].yes,
                cancelText: this.$i18n.messages[this.$i18n.locale].cancel,
                accept: this.handleChange,
            })
        },
        handleChange() {
            const payload = {
                id: this.id,
                status: !this.status
            }
            request
                .updateVendor(payload)
                .then((res) => {
                    this.$vs.notify({
                        color: 'success',
                        title: 'Success',
                        text: 'Vendor Updated',
                    })
                    this.$emit('success', true)
                })
                .catch((res) => {
                    this.$vs.notify({
                        color: 'Warning',
                        title: 'Error',
                        text: 'Vendor Updated',
                    })
                    //this.showValidationErrors(res)
                })
        },
    }
}
</script>

<style></style>